import { render } from "./LayoutsList.vue?vue&type=template&id=1eddec8a&scoped=true"
import script from "./LayoutsList.vue?vue&type=script&lang=js"
export * from "./LayoutsList.vue?vue&type=script&lang=js"

import "./LayoutsList.vue?vue&type=style&index=0&id=1eddec8a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eddec8a"]])

export default __exports__